// Default seed content for QuickDrop Go. Used to (a) seed the local fallback store
// and (b) act as a safe fallback for the public site if the store is empty.
import { contactInfo, legalContent } from "../data/content";

export const defaultServices = [
  { id: "grocery", title: "Grocery", desc: "Fresh produce, pantry staples & daily essentials at your door in minutes.", iconName: "ShoppingCart", image: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=240&q=75", order: 1, enabled: true, comingSoon: false },
  { id: "food", title: "Food Delivery", desc: "Piping hot meals from the best local kitchens across Agartala.", iconName: "UtensilsCrossed", image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=240&q=75", order: 2, enabled: true, comingSoon: false },
  { id: "cosmetics", title: "Cosmetics", desc: "Beauty, skincare & personal care from trusted brands.", iconName: "Sparkles", image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?auto=format&fit=crop&w=240&q=75", order: 3, enabled: true, comingSoon: false },
  { id: "electronics", title: "Electronics", desc: "Gadgets, accessories & repairs delivered safely and fast.", iconName: "Smartphone", image: "https://images.unsplash.com/photo-1498049794561-7780e7231661?auto=format&fit=crop&w=240&q=75", order: 4, enabled: true, comingSoon: false },
  { id: "gifts", title: "Gifts", desc: "Thoughtful surprises wrapped and delivered for every occasion.", iconName: "Gift", image: "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?auto=format&fit=crop&w=240&q=75", order: 5, enabled: true, comingSoon: false },
  { id: "local", title: "Local Delivery", desc: "Send anything, anywhere within the city — quick point-to-point drops.", iconName: "MapPin", image: "https://images.unsplash.com/photo-1601924994987-69e26d50dc26?auto=format&fit=crop&w=240&q=75", order: 6, enabled: true, comingSoon: false },
  { id: "home", title: "Home Services", desc: "Trusted professionals for your home. Launching soon.", iconName: "Wrench", image: "", order: 7, enabled: true, comingSoon: true },
];

export const defaultCategories = [
  { id: "birthday", title: "Birthday Gifts", image: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=240&q=75", order: 1, enabled: true },
  { id: "anniversary", title: "Anniversary Gifts", image: "https://images.unsplash.com/photo-1518895949257-7621c3c786d7?auto=format&fit=crop&w=240&q=75", order: 2, enabled: true },
  { id: "wedding", title: "Wedding Gifts", image: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=240&q=75", order: 3, enabled: true },
  { id: "baby", title: "Baby Shower Gifts", image: "https://images.unsplash.com/photo-1519689680058-324335c77eba?auto=format&fit=crop&w=240&q=75", order: 4, enabled: true },
  { id: "festival", title: "Festival Gifts", image: "https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&w=240&q=75", order: 5, enabled: true },
  { id: "cakes", title: "Cakes", image: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?auto=format&fit=crop&w=240&q=75", order: 6, enabled: true },
  { id: "flowers", title: "Flowers", image: "https://images.unsplash.com/photo-1490750967868-88aa4486c946?auto=format&fit=crop&w=240&q=75", order: 7, enabled: true },
  { id: "chocolates", title: "Chocolates", image: "https://images.unsplash.com/photo-1548907040-4baa42d10919?auto=format&fit=crop&w=240&q=75", order: 8, enabled: true },
  { id: "teddy", title: "Teddy Bears", image: "https://images.unsplash.com/photo-1559454403-b8fb88521f11?auto=format&fit=crop&w=240&q=75", order: 9, enabled: true },
  { id: "decorations", title: "Decorations", image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?auto=format&fit=crop&w=240&q=75", order: 10, enabled: true },
  { id: "hampers", title: "Gift Hampers", image: "https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&w=240&q=75", order: 11, enabled: true },
];

export const defaultContent = {
  hero: {
    badge: "Now delivering across Agartala, Tripura",
    title: "Everything You Need, Delivered Fast.",
    subtitle:
      "Groceries, food, gifts and more from your favourite local stores — delivered to your door in minutes. One app for everything your city has to offer.",
    primaryCta: "Download the App",
    secondaryCta: "Explore Services",
  },
  about:
    "QuickDrop Go is Agartala's own quick-commerce platform, connecting you with trusted local stores and reliable riders to bring everything you need to your doorstep — fast.",
  features: [
    { n: "01", title: "Fast Delivery", desc: "Lightning-quick drops with live tracking so you always know where your order is.", iconName: "Zap" },
    { n: "02", title: "Trusted Local Stores", desc: "We partner only with verified, quality local businesses you already love.", iconName: "Store" },
    { n: "03", title: "Affordable Delivery", desc: "Transparent, low delivery fees with no surprise charges at checkout.", iconName: "Wallet" },
    { n: "04", title: "Secure Payments", desc: "Bank-grade encryption keeps every transaction safe and private.", iconName: "ShieldCheck" },
    { n: "05", title: "Premium Support", desc: "Real humans, ready to help you 7 days a week whenever you need us.", iconName: "Headset" },
  ],
  contact: {
    whatsapp: contactInfo.whatsapp,
    whatsappLink: contactInfo.whatsappLink,
    email: contactInfo.email,
    address: contactInfo.address,
    mapEmbed: contactInfo.mapEmbed,
  },
  footerAbout:
    "Everything you need, delivered fast. Groceries, food, gifts and more from your favourite local stores in Agartala, Tripura.",
  socialLinks: [
    { label: "Instagram", href: "https://instagram.com" },
    { label: "Facebook", href: "https://facebook.com" },
    { label: "Twitter", href: "https://twitter.com" },
    { label: "LinkedIn", href: "https://linkedin.com" },
  ],
  faq: [
    { q: "Which areas do you deliver to?", a: "We currently deliver across Agartala, Tripura, and are expanding to nearby areas soon." },
    { q: "How long does delivery take?", a: "Most orders arrive within 15–30 minutes depending on your location and the store." },
    { q: "How can I become a partner store or rider?", a: "Use the Become a Partner or Become a Rider forms on this website and our team will reach out." },
  ],
  privacy: legalContent.privacy,
  terms: {
    title: "Terms & Conditions",
    updated: "Last updated: December 2025",
    body: [
      "By using the QuickDrop Go website and app, you agree to these Terms & Conditions.",
      "Submitting a registration form does not guarantee onboarding; all applications are subject to verification.",
      "QuickDrop Go is not liable for indirect losses arising from third-party partner or rider services.",
    ],
  },
};

export const defaultSettings = {
  siteName: "QuickDrop Go",
  logoUrl: "",
  faviconUrl: "",
  seoTitle: "QuickDrop Go — Everything You Need, Delivered Fast.",
  seoDescription:
    "Groceries, food, gifts and more delivered in minutes across Agartala, Tripura. Download the QuickDrop Go app.",
  ogImage: "",
  maintenanceMode: false,
  playStoreUrl: "",
};

export const businessCategories = [
  "Grocery", "Restaurant", "Fast Food", "Cosmetics", "Electronics", "Gift Shop", "Pharmacy", "Others",
];
export const vehicleTypes = ["Bicycle", "Motorcycle", "Scooter", "Car", "Electric Vehicle"];
